import React, { useContext, useEffect } from "react";
import close from "../../images/Svg/close.svg";
import rocket from "../../images/Svg/rocket.svg";
import { useNavigate } from "react-router-dom";
import { gaEvents, pushGaEvent } from "../../utils/ga_events";

export default function LoginModal({ show, setShow, desoLogin }) {
  const navigate = useNavigate();
  const handleClick = (value) => {
    if (value) {
      pushGaEvent(gaEvents.LOGIN_WITH_DESO_BUTTON_CLICKED);
    } else {
      pushGaEvent(gaEvents.SIGN_UP_WITH_DESO_BUTTON_CLICKED);
    }
    desoLogin();
  };
  return (
    <div className="another_style">
      <div className="invite_section_1 w-[620px] py-[20px]">
        <div className="flex justify-end w-[95%]">
          <img
            onClick={() => setShow(false)}
            className="cursor-pointer"
            src={close}
            alt=""
          />
        </div>
        <div className="max-w-[300px] sm:max-w-[300px] md:max-w-[350px] w-[100%] mx-auto text-center pt-[20px] pb-[40px]">
          <img className="mx-auto" src={rocket} alt="" />
          <h1 className="text-[#161616] text-[36px]  title font-bold mt-[16px] mb-[8px] leading-[44px]">
            Let's Go! <br />
            Login with DeSo
          </h1>
          <p className="text-[#585858] text-[16px] mb-[24px]">
            Logging in with DeSo allows us to push your content to Web 3.0
          </p>
          <div className="button_hover">
            <button
              onClick={() => handleClick(true)}
              className="bg-[#5463FF] w-[278px] py-[16px] px-[32px] mb-[48px] text-white rounded-[12px]"
            >
              Login with DeSo
            </button>
          </div>

          <h3 className="text-[24px] font-bold">New to DeSo? Let us help</h3>
          <button
            onClick={() => handleClick(false)}
            className="bg-[#FFFFFF] text-black py-[16px] px-[32px] mt-[16px] rounded-[12px] w-[278px] border border-[#E1E1E1] hover:bg-[#EEEFFF]"
          >
            Signup on DeSo
          </button>
        </div>
      </div>
    </div>
  );
}
